import { useContext, useState } from 'react';
import { IdentityContext } from '../../identity/state/IdentityContext';

/**
 * The one way out of the employee screens. An Employee-role session is given the onboarding card layout only (no admin shell, no menu),
 * so without this a person who ends up in an employee session, such as an administrator whose browser session was replaced, would have
 * no way to leave. Reads the identity context directly and renders nothing without one, so the layout still renders in isolation.
 */
export function EmployeeSignOut() {
  const identity = useContext(IdentityContext);
  const [busy, setBusy] = useState(false);
  if (!identity?.me) return null;

  async function signOut() {
    setBusy(true);
    try {
      await identity?.logout();
    } finally {
      setBusy(false);
    }
  }

  return (
    <button type="button" className="eo-signout" onClick={() => void signOut()} disabled={busy}>
      {busy ? 'Signing out…' : 'Sign out'}
    </button>
  );
}
